import React from "react";
import { motion } from "framer-motion";
import { Paper, Typography } from "@mui/material";
import { useThemeContext } from "./ThemeWrapper";

const RightPanel: React.FC = () => {
  const { isDarkTheme } = useThemeContext();
  // Removed mobileMenuOpen state as mobile menu logic is removed from this component

  return (
    // Desktop Right Panel - This will be hidden on screens smaller than 'md'
    <aside
      className={`hidden md:flex flex-col w-80 p-8 border-l transition-colors duration-300 
        ${isDarkTheme
          ? "bg-gray-800 border-gray-700"
          : "bg-gray-50 border-gray-200"}`}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
      >
        <Paper
          elevation={4}
          className={`p-6 rounded-2xl shadow-lg transition-all duration-300 
            ${isDarkTheme
              ? "bg-gray-900 border border-gray-700"
              : "bg-white border border-gray-200"}`}
        >
          <Typography
            variant="h6"
            component="h3"
            className="!font-bold mb-4"
            style={{
              color: isDarkTheme ? "#60a5fa" : "#1e3a8a",
            }}
          >
            🚀 Create a profile to save your progress!
          </Typography>

          <motion.button
            className="w-full mb-3 py-3 font-semibold rounded-xl text-white 
                       bg-emerald-600 hover:bg-emerald-700 dark:bg-emerald-500 dark:hover:bg-emerald-400"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
          >
            CREATE PROFILE
          </motion.button>

          <motion.button
            className="w-full py-3 font-semibold rounded-xl text-white 
                       bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-400"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
          >
            SIGN IN
          </motion.button>
        </Paper>
      </motion.div>
    </aside>
  );
};
export default RightPanel;